import { close, play } from '@equinor/eds-icons';
import {
  Button,
  Chip,
  Icon,
  LinearProgress,
  Typography,
} from '@equinor/eds-core-react';
import * as Styled from './SimulationProgress.styled';

Icon.add({ close, play });

interface SimulationProgressProps {
  percentComplete: number;
  stepsGenerated: number;
  totalSteps: number;
  timeRemaining: string | null;
  onStop?: () => void;
  onDelete?: () => void;
  onStart?: () => void;
  isProcessing: boolean;
  status: 'not-started' | 'running' | 'completed' | 'failed';
}

export const SimulationProgress = ({
  percentComplete,
  stepsGenerated,
  totalSteps,
  timeRemaining,
  onStop,
  onDelete,
  onStart,
  isProcessing,
  status,
}: SimulationProgressProps) => {
  const statusText =
    status === 'not-started'
      ? 'Not started'
      : status === 'running'
      ? 'Running...'
      : status === 'failed'
      ? 'Failed'
      : 'Completed';
  const chipVariant =
    status === 'running' ? 'active' : status === 'failed' ? 'error' : 'default';

  return (
    <Styled.Container>
      <Styled.Header>
        <Typography variant="h4">Simulation progress</Typography>
        <Chip variant={chipVariant}>{statusText}</Chip>
      </Styled.Header>

      <Styled.ProgressSection>
        <LinearProgress variant="determinate" value={percentComplete} />

        <Styled.ProgressInfo>
          <Typography variant="body_short">
            {percentComplete.toFixed(1)}% complete • {stepsGenerated} of{' '}
            {totalSteps} steps generated
            {timeRemaining != null && ` • ${timeRemaining} remaining`}
          </Typography>

          {status === 'not-started' && onStart && (
            <Button variant="ghost" onClick={onStart}>
              <Icon name="play" size={16} />
              Start simulation
            </Button>
          )}
          {isProcessing && onStop && (
            <Button variant="ghost" onClick={onStop}>
              <Icon name="close" size={16} />
              Stop simulation...
            </Button>
          )}
          {(status === 'failed' || status === 'completed') && onDelete && (
            <Button variant="ghost" color="danger" onClick={onDelete}>
              <Icon name="close" size={16} />
              Delete simulation
            </Button>
          )}
        </Styled.ProgressInfo>
      </Styled.ProgressSection>
    </Styled.Container>
  );
};
